<template>
  <v-container style="max-width:1000px">
    <h1>Sivua ei löydy</h1>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
};
</script>
